import { z } from 'my-zod'
import { customerOrdersModel } from './customer-order-model'
import { customerOrderBookingPlatformOptions } from './booking-platform'

export const customerOrderSystemView = customerOrdersModel.augment({
  bookingPlatform: z.enum(customerOrderBookingPlatformOptions)
})
export type customerOrderSystemView = z.infer<typeof customerOrderSystemView>
